module.exports = __webpack_public_path__ + "img/ic-loading.7677a18f.gif";